<app-header [tiny]="true">
  <a
    appButton
    name="DONTREPORT"
    location="asset-header"
    [iconButton]="true"
    color="hard-simple"
    height="1"
    (click)="close()"
    shape="round"
    class="back"
    [appTooltip]="'back-to-gallery' | translate"
    tooltipKeyboardShortcut="ESC"
    toolTipOrigin="right"
  >
    <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
  </a>
  <app-asset-page-meta
    [asset]="asset"
    [thumbnailBarOpen]="thumbnailBarOpen"
    [gallery]="gallery"
    [accessLevel]="accessLevel"
    [activeIndex]="activeIndex"
    (onThumbnailBarOpen)="onThumbnailBarOpen.emit($event)"
  >
  </app-asset-page-meta>
  <div class="spacer"></div>
  <div class="right-buttons">
    @if (clientMode) {
      @if (state.user || state.guest?.email) {
        <app-context-menu [options]="{ width: '320px', noSpacing: true }" #menu>
          <div
            appClickTrack
            name="profile-circle"
            location="asset-header"
            class="profile-circle"
            appTooltip="Your Profile"
            data-test-id="profile-circle"
            [class.auto-border]="(state.user | avatarType) === 'image'"
            contextButton
          >
            <app-avatar [user]="state.user || state.guest"></app-avatar>
          </div>
          <app-view-profile-menu
            [accessLevel]="accessLevel"
            [gallery]="gallery"
            contextContent
            (onClose)="menu.close()"
          ></app-view-profile-menu>
        </app-context-menu>
      } @else if (accessLevel !== 'view_only') {
        <div
          class="profile-circle"
          appTooltip="Your Profile"
          data-test-id="profile-circle"
          [class.auto-border]="(state.user | avatarType) === 'image'"
          (click)="openGuestProfileDialog()"
        >
          <app-avatar [user]="state.user || state.guest"></app-avatar>
        </div>
      }
    }
    <app-context-menu
      class="guest-info"
      [options]="{ width: '233px' }"
      verticalPosition="bottom"
      position="center"
      #anonymousGuestInfo
    >
      <div contextContent (click)="anonymousGuestInfo.close(); openGuestProfileDialog()" class="guest-info-content">
        You left feedback anonymously. Click here to add your info and let others know who you are.
      </div>
    </app-context-menu>

    @if (!clientMode && accessLevel === 'edit') {
      <app-context-menu [options]="{ width: '380px', noSpacing: true }" #activityMenu>
        <button
          appButton
          contextButton
          name="activity"
          location="edit-gallery-header"
          color="hard-simple"
          [iconButton]="true"
          shape="round"
          data-test-id="gallery-activity"
          weight="bold"
          height="1"
          heightMobile="0-5"
          appTooltip="Show activity"
        >
          <!-- removed at the moment because it will never show any activity, because by visiting the asset page you have already marked the activity as seen-->
          <!-- <app-activity-badge [asset]="asset" [hideBolt]="true" [color]="'grey-80'" [hideWhenEmpty]="true">
          </app-activity-badge> -->
          <app-svg src="/assets/icons/bolt.svg"></app-svg>
        </button>

        <div contextContent>
          @if (activityMenu.isOpen) {
            <app-asset-activity-menu
              [gallery]="gallery"
              [asset]="asset"
              (closeContext)="activityMenu.close()"
            ></app-asset-activity-menu>
          }
        </div>
      </app-context-menu>
    } @else if (allowDownload()) {
      <app-asset-download-button
        location="asset-header"
        [asset]="asset"
        [gallery]="gallery"
        [accessLevel]="accessLevel"
        [previewWidth]="previewWidth"
      >
        <button
          appButton
          name="download"
          location="asset-header"
          [iconButton]="true"
          shape="round"
          color="simple-gray"
          height="1"
        >
          <app-svg src="/assets/icons/download.svg" color="grey-30"></app-svg>
        </button>
      </app-asset-download-button>
    }

    @if (!clientMode && accessLevel === 'edit') {
      <app-context-menu [options]="{ width: '240px', noSpacing: true }" #assetContextMenu [position]="'right'">
        <button
          appButton
          name="options"
          location="asset-sidebar"
          [iconButton]="true"
          height="1"
          shape="round"
          color="hard-simple"
          appTooltip="More options"
          contextButton
          data-test-id="asset-sidebar-more"
          #button
        >
          <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
        </button>
        <div contextContent>
          @if (
            assetContextMenu.isOpen || (contextService.onContextOpen | async | inferredContextOpen: 'asset-' + asset.id)
          ) {
            <app-asset-context-menu
              [asset]="asset"
              [gallery]="gallery"
              [accessLevel]="accessLevel"
              [clientEl]="button"
              (onClose)="assetContextMenu.close()"
              (onToggleThumbnails)="onThumbnailBarOpen.emit($event)"
              (openShare)="openShareDialog()"
              (onDelete)="onDeleteAsset()"
              (onNewVersion)="onUpload.emit()"
            >
            </app-asset-context-menu>
          }
        </div>
      </app-context-menu>
    }
    <button
      appButton
      name="info"
      location="asset-header"
      data-test-id="asset-info-button"
      [iconButton]="true"
      height="1"
      shape="round"
      color="hard-simple"
      (click)="onShowInfo.emit()"
      [appTooltip]="'asset-information' | translate"
      [toolTipOrigin]="'left'"
      [tooltipKeyboardShortcut]="'I'"
    >
      <app-svg src="/assets/icons/info-outline.svg"></app-svg>
    </button>
  </div>
</app-header>
